"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var subscribtion_service_1 = require("./../Services/subscribtion.service");
var core_1 = require("@angular/core");
var service_service_1 = require("../Services/service.service");
var AdView;
(function (AdView) {
    AdView[AdView["Advertisement"] = 0] = "Advertisement";
    AdView[AdView["Payment"] = 1] = "Payment";
})(AdView = exports.AdView || (exports.AdView = {}));
var BuyThirdPartyComponent = /** @class */ (function () {
    function BuyThirdPartyComponent(services, subscriptionService) {
        this.services = services;
        this.subscriptionService = subscriptionService;
    }
    BuyThirdPartyComponent.prototype.ngOnInit = function () {
    };
    return BuyThirdPartyComponent;
}());
exports.BuyThirdPartyComponent = BuyThirdPartyComponent;
